// extracted by mini-css-extract-plugin
module.exports = {"cursor-pointer":"TagsFilter-6871455e-scss"};